import { createIcon } from "@chakra-ui/icons";

// Created from calendar.svg

export const CalendarIcon = createIcon({
  displayName: "Add",
  viewBox: "0 0 94 94",
  path: (
    <g>
      <path
        d="M59.375 12.5H15.625C12.1732 12.5 9.375 15.2982 9.375 18.75V62.5C9.375 65.9518 12.1732 68.75 15.625 68.75H59.375C62.8268 68.75 65.625 65.9518 65.625 62.5V18.75C65.625 15.2982 62.8268 12.5 59.375 12.5Z"
        stroke="#FAFDFF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 6.25V18.75"
        stroke="#FAFDFF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 6.25V18.75"
        stroke="#FAFDFF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 31.25H65.625"
        stroke="#FAFDFF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});
